import React from 'react';
import './text-input.scss';

export const TextInput = () => {
  return (
    <input type="text" className="app-text-input d-block" placeholder="Hoop Heaven" />
  )
}